import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, UrlSegment } from '@angular/router';
import { Subject } from "rxjs";
import { User } from '../../models/User';
import { AuthService } from '../../services/auth.service';
import { ProductService } from '../../services/product.service';
import { AdminUrlType } from "../../services/utility/general-helper.service";

//moved to general-helper service
// enum AdminUrlType{
//   Dashboard,
//   ProductList,
//   ProductAdd,
//   ProductEdit,
//   Customers
// }

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  AdminUrlType = AdminUrlType;
  urlType:AdminUrlType = null;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  category:string = null;
  category_formatted:string;
  sku:string = null;
  // id:number = null;  //not presently used, 
  //   -- b/c product edit is still conducted via sku which pertains to the original product, 
  //      not the editable copy which could have sku edited out from underneath it.
  
  constructor(
    private route:ActivatedRoute,
    private authService:AuthService,
    private productService:ProductService,
  ) { }

  ngOnInit() { 
    // console.log('admin init');

    //**NOTE - See products.component for a better way to 'chain' observables.
    //  *You don't want to have to pass around a 'result' object.
    //  *I'm leaving this here just to show how it is done.
    //  *Ideally you handle the parameter logic wihin each 'mergeMap' or 'switchMap'.

    //1 - evaluate the url on each change
    //2 - merge the results each time with one/first observation of params.
    //    *mergeMap will subscribe params for each observation of url, so 
    //     you need 'first()' so that params observation isn't duplicated.
    this.route.url
    .mergeMap(
      (url:UrlSegment[]) => {
        // console.log('mergemap merges results with a fresh observation of params, so use first()');
        return this.route.params.first().map((params:Params) => { return {url:url, params:params} });
      }
    )
    .mergeMap( (result:{url:UrlSegment[], params:Params}) => {
      return this.authService.user$.map((user:User) => {
        return {url:result.url, params:result.params, user:user}
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((result:{url:UrlSegment[], params:Params, user:User}) => {
      // console.log('admin results', result);
      //set local properties using route parameters
      let url = result.url;
      // console.log('admin url:', url[2]);
      let params = result.params;
      // console.log('params', params);
      this.category = params['category'];
      this.sku = params['sku'];
      this.urlType = this.getAdminUrlType(url, this.category, this.sku);
      this.category_formatted = this.getCategoryFormatted(this.category);
    });

    
  }


  //Determine the AdminUrlType using url and parameters
  getAdminUrlType(url, category:string, sku:string){
    let urlType = AdminUrlType.Dashboard;  //default
    // console.log('category '+category+', sku '+sku);
    let url2 = url[2] ? url[2].path : undefined;  //add, edit, or undefined
    if(!category){
      urlType = AdminUrlType.Dashboard;
    } else if(category == 'customers'){
      urlType = AdminUrlType.Customers;
    } else if (category == 'products'){
      if(!sku){
        if(url2 == 'add') { urlType = AdminUrlType.ProductAdd; }
        else { urlType = AdminUrlType.ProductList; }
      } else {
        urlType = AdminUrlType.ProductEdit;
      }
    } else {
      console.log('admin-component: url not handled.  Using default urltype \'list\'');  
    }

    // let urlTypeAsString = AdminUrlType[urlType];  //Convert enum value to string
    // console.log('urlType', urlTypeAsString);
    return urlType;
  }

  //properly formated 'category' to appear in the breadcrumb
  getCategoryFormatted(category){
    var category_formatted = category;
    switch (category) {
      case 'dashboard':
        category_formatted = '';
        break;
      case 'products':
        category_formatted = 'Products';
        break;
      case 'productedit':
        category_formatted = 'Products';
        break;
      case 'customers':
        category_formatted = 'Customers';
        break;    
      default:
        break;
    }
    return category_formatted;
  }

  ngOnDestroy() {
    // console.log('*products component destroyed')
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
   }


}





//======================
// Unused Code


// this.url = this.router.url.replace('/','');
//'/admin'

// this.url = this.router.url;
// console.log(this.url);

// //This works, but better way is to use route.params
// this.activatedRoute.url.subscribe(urlsegments=>{
  
//   let path0 = urlsegments[0];
//   let path1 = urlsegments[1];
//   let path2 = urlsegments[2];
//   console.log('path0', path0);
//   console.log('path1', path1);
//   console.log('path2', path2);
//   this.url = '/'+path0;
//   this.url += path1 ? '/'+path1 : '';
//   this.url += path2 ? '/'+path2 : '';
//   console.log('this.url', this.url);
// });

// this.activatedRoute.url.subscribe((e) => {
//   //use route params to set local properties
//   console.log('e', e);

// });

    
// console.log('this.admincategory', this.admincategory);
// console.log('this.productsku', this.productsku);
// console.log('this.urlType', this.urlType);

// this.category_formatted = this.getCategoryFormatted(this.category);

// if(this.productsku){
//   this.urlType = AdminUrlType.ProductEdit;
// } else if (this.admincategory == 'products'){
//   this.urlType = AdminUrlType.ProductList;
// } else if (this.admincategory == 'customers'){
//   this.urlType = AdminUrlType.Customers;
// } else if (this.admincategory == null){
//   this.urlType = AdminUrlType.Dashboard;
// }

//Params.first() causes it to only reveal params when appRoutes changes.  Thus if component is reused such as when toggling between categories, params won't be evaluated.
    // console.log('admin init');
    // this.route.params.first().subscribe((params:Params) => { 
    //   console.log('admin params', params);
    // });
      // this.route.params.first().subscribe((params: Params) => {
      //   this.category = params["category"];
      //   this.sku = params["sku"];
      //   let url = this.route.url.subscribe((url) => {
      //     console.log('params', params);
      //     this.urlType = this.getAdminUrlType(url, this.sku);
      //     this.category_formatted = this.getCategoryFormatted(this.category);
      //   });
      // });


    // let isEdit = url[1] != null ? url[1].path == 'edit' : false;
    // if(isEdit == false){
    //   if(sku == null){
    //     urlType = AdminUrlType.ProductList
    //   } else {
    //     urlType = AdminUrlType.Dashboard
    //   }
    // } else {
    //   let editType = url[2].path  //(for admin): card, detail, or edit    
    //   if(editType == 'card'){
    //     urlType = AdminUrlType.ProductEdit;
    //   } else if(editType == 'detail'){
    //     urlType = AdminUrlType.Customers;
    //   } else {
    //     console.log('p-component: url not handled:', url);  
    //     console.log('using default urltype \'list\'');
    //     urlType = AdminUrlType.ProductList;
    //   }
    // }


  // {path: 'admin'
  // {path: 'admin/:category'
  // {path: 'admin/:category/edit/:sku'
  // {path: 'admin/customers'

  //AdminUrlType pseudocode
  //1 - category is null: dashboard
  //2 - category is customers: customers
  //3 - category is products, and sku is null: product-list
  //4 - category is products, and sku != null: product-edit

  
    // //not presently used.  
    // //when productService retrieves products, set this.id to property.property_id
    // // note: products is initially null.
    // // note2: this.sku will not refer to a valid product if user edits sku number.
    // this.productService.product$
    // .takeUntil(this.ngUnsubscribe)
    // .subscribe((products) => {
    //   if(this.sku && products && products.length > 0){
    //     let product = this.productService.getProductBySku(this.sku);
    //     // if(product){ this.id = product.product_id; }  // presently not used
    //   }
    // })


// WEBPACK FOOTER //
// ./src/app/components/admin/admin.component.ts